"use client";

import { useEffect } from "react";
import logger from "@/lib/logger.mjs";

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    // Create a mock request object with client-side context
    const mockReq = {
      url: window.location.pathname,
      method: "GET",
      headers: {
        "user-agent": window.navigator.userAgent,
        host: window.location.host,
        "x-forwarded-for": "",
      },
    };

    logger.error(error, mockReq);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <h2 className="text-2xl font-bold text-red-600 mb-4">
          Something went wrong!
        </h2>
        <p className="text-gray-600 mb-4">
          We apologize for the inconvenience. Our team has been notified and
          is working to fix the issue.
        </p>
        <button
          onClick={() => reset()}
          className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
